import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const CONSENT_KEY = "wc_cookie_consent";

const updateGtagConsent = (granted) => {
  if (typeof window === "undefined" || typeof window.gtag !== "function") return;
  window.gtag("consent", "update", {
    ad_storage: granted ? "granted" : "denied",
    analytics_storage: granted ? "granted" : "denied",
    ad_user_data: granted ? "granted" : "denied",
    ad_personalization: granted ? "granted" : "denied",
  });
};

const CookieConsent = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      const saved = localStorage.getItem(CONSENT_KEY);
      if (!saved) setVisible(true);
    } catch (e) {
      setVisible(true);
    }
  }, []);

  const handleAcceptAll = () => {
    try {
      localStorage.setItem(CONSENT_KEY, "all");
    } catch (e) {}
    updateGtagConsent(true);
    setVisible(false);
  };

  const handleReject = () => {
    try {
      localStorage.setItem(CONSENT_KEY, "essential");
    } catch (e) {}
    updateGtagConsent(false);
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      role="dialog"
      aria-live="polite"
      aria-label="Cookie consent"
      className="fixed bottom-0 left-0 right-0 z-[9998] bg-[#101F27]/95 backdrop-blur-lg border-t border-[#009688]/40 shadow-2xl"
      data-testid="cookie-consent-banner"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-5 flex flex-col md:flex-row md:items-center gap-4">
        <p className="text-sm text-gray-300 leading-relaxed flex-1">
          We use cookies to enhance your experience, analyze site traffic, and assist with marketing.
          Essential cookies are always on. You can accept all cookies or reject non-essential ones.
          Learn more in our{" "}
          <Link to="/privacy-policy" className="text-[#009688] hover:underline font-semibold">
            Privacy Policy
          </Link>.
        </p>
        <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-3 md:flex-shrink-0">
          <button
            type="button"
            onClick={handleReject}
            data-testid="cookie-reject-btn"
            className="px-5 py-2 rounded-md border border-gray-600 text-gray-200 hover:border-[#009688] hover:text-[#009688] transition-colors text-sm font-semibold"
          >
            Reject Non-Essential
          </button>
          <button
            type="button"
            onClick={handleAcceptAll}
            data-testid="cookie-accept-btn"
            className="px-5 py-2 rounded-md bg-gradient-to-r from-[#009688] to-[#005B4F] hover:from-[#005B4F] hover:to-[#009688] text-white shadow-lg shadow-[#009688]/20 text-sm font-semibold"
          >
            Accept All
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
